module.exports = __webpack_public_path__ + "static/media/icomoon.fed426a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.svg
// module id = 1044
// module chunks = 110